const ACHIEVEMENT_KEY = import.meta.env.VITE_ACHIEVEMENT_KEY || ''

function decrypt(encryptedText) {
  if (!ACHIEVEMENT_KEY || !encryptedText) return encryptedText || ''
  encryptedText = decodeURIComponent(encryptedText)
  let decrypted = ''
  for (let i = 0; i < encryptedText.length; i++) {
    const charCode =
      encryptedText.charCodeAt(i) ^ ACHIEVEMENT_KEY.charCodeAt(i % ACHIEVEMENT_KEY.length)
    decrypted += String.fromCharCode(charCode)
  }
  return decrypted
}

function encrypt(text) {
  if (!ACHIEVEMENT_KEY || !text) return text || ''
  let encrypted = ''
  for (let i = 0; i < text.length; i++) {
    const charCode = text.charCodeAt(i) ^ ACHIEVEMENT_KEY.charCodeAt(i % ACHIEVEMENT_KEY.length)
    encrypted += String.fromCharCode(charCode)
  }
  return encodeURIComponent(encrypted)
}

export { decrypt, encrypt }
